export default __webpack_public_path__ + "static/media/estado-25.dcd30938.svg";